export default __webpack_public_path__ + "static/media/beeSwarm2.d974cd08.jpg";